"use strict";

exports.__esModule = true;
var _DescriptionList = require("./DescriptionList");
Object.keys(_DescriptionList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DescriptionList[key]) return;
  exports[key] = _DescriptionList[key];
});
var _DescriptionListItem = require("./DescriptionListItem");
Object.keys(_DescriptionListItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DescriptionListItem[key]) return;
  exports[key] = _DescriptionListItem[key];
});